import type { FaireProductEntity } from "../../entity_types/product";

export const p_4z77wnfamb: FaireProductEntity = {
  token: "p_4z77wnfamb",
  type: "product",
  name: "Meditating Buddha Statue - 29In High",
  brandToken: "b_6clm7lye",
  brandName: "Hi-Line Gift Ltd.",
  imageUrl:
    "https://cdn.faire.com/fastly/56b71825b4d8a7bcb69af75f84dd9042469cddc681465e3667aaca2859f88d20.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7a1526210e4b31bebf2e9988d79de935bb65b48069be867596e719b0e4b6d3aa.jpeg",
    "https://cdn.faire.com/fastly/d714109f51b2ca337472daae8b5e09c473fb500908b2ce7e9e18dda3d2e7cb4f.jpeg",
  ],
  priceDollars: 152.5,
  description:
    "Tune into zen and tranquility with  this detailed 29in buddha statue. Place it in your home or garden and create a space for relaxation and meditation. Finely crafted detail.",
  tags: [],
  msrpDollars: 331,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:58.759Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
